import apiClient from './apiClient';

// ============================================================
// Types -- matching backend Go models
// ============================================================

export interface F905 {
  f905_01: string;        // 員工代號 (PK)
  f905_11: string;        // 代理人1
  f905_12: string;        // 代理人2
  f905_13: string;        // 代理人3
  f905_14: string;        // 代理人4
  f905_15: string;        // 代理人5
  f905_21: string;        // 使用權限部門代碼1
  f905_22: string;        // 使用權限部門代碼2
  f905_23: string;        // 使用權限部門代碼3
  f905_24: string;        // 使用權限部門代碼4
  f905_25: string;        // 使用權限部門代碼5
  f905_91: string;        // 建立者
  f905_92: string | null; // 建立日期
  f905_93: string;        // 最後修改者
}

export interface CreateRequest {
  f905_01: string;
  f905_11?: string;
  f905_12?: string;
  f905_13?: string;
  f905_14?: string;
  f905_15?: string;
  f905_21?: string;
  f905_22?: string;
  f905_23?: string;
  f905_24?: string;
  f905_25?: string;
}

export interface UpdateRequest {
  f905_11?: string;
  f905_12?: string;
  f905_13?: string;
  f905_14?: string;
  f905_15?: string;
  f905_21?: string;
  f905_22?: string;
  f905_23?: string;
  f905_24?: string;
  f905_25?: string;
}

export interface ListResponse {
  data: F905[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const proxySettingApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/proxy-setting', { params });
    return res.data;
  },

  async get(code: string): Promise<F905> {
    const res = await apiClient.get(`/api/proxy-setting/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F905> {
    const res = await apiClient.post('/api/proxy-setting', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F905> {
    const res = await apiClient.put(`/api/proxy-setting/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/proxy-setting/${encodeURIComponent(code)}`);
  },
};
